import { VLayout } from '@sleepstation/components-layouts'
import { backgroundImageLinearGradient } from '@sleepstation/style-api-helpers'
import { constrainWide } from '@sleepstation/style-mixins'
import { reversedTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import Lower from '../../shared/Lower'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout)`
  ${backgroundImageLinearGradient()}
`

const Inner = styled.div`
  ${constrainWide()}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SecondaryFooter = ({ legalPages, informationStandardPath }) => (
  <ThemeProvider theme={reversedTheme}>
    <Layout>
      <Inner>
        <Lower
          legalPages={legalPages}
          informationStandardPath={informationStandardPath}
        />
      </Inner>
    </Layout>
  </ThemeProvider>
)

SecondaryFooter.propTypes = {
  legalPages: PropTypes.arrayOf(PropTypes.object).isRequired,
  informationStandardPath: PropTypes.string.isRequired,
}

export default SecondaryFooter
